module.exports = __webpack_public_path__ + "static/media/CeoAsagba.1a087179.jpg";